import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';
import CustomerTransferGateway from '~apis/customerTransfer';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateCustomerTransfer(api: CustomerTransferGateway): SagaWatcherReturnType {
    yield takeEvery('customerTransfer/customerTransferCreateNewCustomerTransferAttempt', handleCreateCustomerTransfers, api);
}

function* handleCreateCustomerTransfers(api: CustomerTransferGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const draftId = reduxState.customerTransfer.customerTransferDraftId.draftId;

    const response = yield* call([api, api.createNewCustomerTransfer], {
        authToken,
        draftId: draftId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.customerTransferCreateNewCustomerTransferFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerTransferSetCreateCustomerTransferModalIsOpen(false));
        yield put(combinedActions.customerTransferSetIsFormFilled(false));
        yield put(combinedActions.customerTransferCreateNewCustomerTransferSuccess());
        yield put(combinedActions.customerTransferGetCustomerTransferListingAttempt());
        toast.success(SuccessMessages.CreateCustomerTransferSuccess)
    }
}
